
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaBoxOpen,
  FaComments,
  FaShoppingCart,
  FaChartBar,
  FaCog,
  FaCity,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

import Logo from "../Logo";
import BtnChangLang from "./../ChangeLang";

function Sidbar({ collapsed, onToggle }) {
  const { t, i18n } = useTranslation();

  const dir = i18n.dir();
  const isRTL = dir === "rtl";

  return (
    <aside
      dir={dir}
      className="dashboard-sidebar d-flex flex-column"
      style={{
        width: collapsed ? "78px" : "260px",
        height: "100vh",

        backgroundColor: "#FFFFFF",

        borderLeft: isRTL ? "1px solid #EEE5E8" : "none",

        borderRight: !isRTL ? "1px solid #EEE5E8" : "none",

        boxShadow: isRTL
          ? "-8px 0 30px rgba(39,39,39,.04)"
          : "8px 0 30px rgba(39,39,39,.04)",

        padding: collapsed ? "18px 10px" : "18px 14px",

        overflowY: "auto",
        overflowX: "hidden",

        transition: "width .3s ease, padding .3s ease",

        position: "relative",
      }}
    >
      {/* =========================================
          HEADER
      ========================================= */}

      <div
        className="d-flex align-items-center mb-4 pb-3"
        style={{
          borderBottom: "1px solid #F0E8EB",

          justifyContent: collapsed ? "center" : "space-between",

          minHeight: "55px",
        }}
      >
        {/* LOGO */}

        {!collapsed && (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              flex: 1,
            }}
          >
            <Logo />
          </div>
        )}

        {collapsed && (
          <div
            className="d-flex align-items-center justify-content-center fw-bold"
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "12px",
              backgroundColor: "#F9E9EE",
              color: "#B5183F",
              fontSize: "20px",
            }}
          >
            N
          </div>
        )}
      </div>


      {/* =========================================
          DASHBOARD TITLE
      ========================================= */}

      <div
        className="d-flex align-items-center mb-3"
        style={{
          gap: collapsed ? "0" : "10px",
          justifyContent: collapsed ? "center" : "flex-start",

          padding: collapsed ? "0" : "0 10px",
        }}
        title={collapsed ? t("dashboard.title", "Dashboard") : ""}
      >
        <div
          className="d-flex align-items-center justify-content-center rounded-3"
          style={{
            width: "36px",
            height: "36px",

            backgroundColor: "#F9E9EE",
            color: "#B5183F",

            flexShrink: 0,
          }}
        >
          <FaCog size={15} />
        </div>

        {!collapsed && (
          <div>
            <div
              className="fw-bold"
              style={{
                color: "#272727",
                fontSize: "14px",
              }}
            >
              {t("dashboard.title", "Dashboard")}
            </div>
          </div>
        )}
      </div>

      {/* =========================================
          NAVIGATION
      ========================================= */}

      <nav className="d-flex flex-column gap-1">
        <NavItem
          to="products"
          icon={<FaBoxOpen />}
          label={t("dashboard.products")}
          collapsed={collapsed}
          dir={dir}
        />

        <NavItem
          to="orders"
          icon={<FaShoppingCart />}
          label={t("dashboard.orders")}
          collapsed={collapsed}
          dir={dir}
        />

        <NavItem
          to="categories"
          icon={<FaChartBar />}
          label={t("dashboard.categories")}
          collapsed={collapsed}
          dir={dir}
        />

        <NavItem
          to="cities"
          icon={<FaCity />}
          label={t("dashboard.cities")}
          collapsed={collapsed}
          dir={dir}
        />

        <NavItem
          to="reviews"
          icon={<FaComments />}
          label={t("dashboard.reviews")}
          collapsed={collapsed}
          dir={dir}
        />
      </nav>

      {/* =========================================
          BOTTOM
      ========================================= */}

      <div
        className="mt-auto pt-4"
        style={{
          width: "100%",
        }}
      >
        <div
          style={{
            height: "1px",
            backgroundColor: "#F0E8EB",
            marginBottom: "10px",
          }}
        />

        <div
          className="d-flex align-items-center justify-content-center rounded-3"
          style={{
            backgroundColor: "#FDFBFC",
            border: "1px solid #EEE5E8",
            minHeight: "40px",

            overflow: "hidden",
          }}
        >
          <BtnChangLang />
        </div>
      </div>
    </aside>
  );
}

// =================================================
// NAV ITEM
// =================================================

function NavItem({ to, icon, label, collapsed, dir }) {
  const isRTL = dir === "rtl";

  return (
    <NavLink
      to={to}
      title={collapsed ? label : ""}
      className={({ isActive }) =>
        `text-decoration-none d-flex align-items-center ${
          isActive ? "dashboard-nav-active" : "dashboard-nav-item"
        }`
      }
      style={{
        position: "relative",

        transition: "all .2s ease",

        fontSize: "13px",
        fontWeight: 600,

        padding: collapsed ? "8px" : "8px 10px",

        borderRadius: "12px",

        gap: collapsed ? "0" : "12px",

        justifyContent: collapsed ? "center" : "flex-start",

        minHeight: "50px",
      }}
    >
      {({ isActive }) => (
        <>
          {/* ICON */}

          <span
            className="d-flex align-items-center justify-content-center rounded-3"
            style={{
              width: "36px",
              height: "36px",

              flexShrink: 0,

              backgroundColor: isActive ? "#B5183F" : "#F9E9EE",

              color: isActive ? "#FFFFFF" : "#B5183F",

              transition: "all .2s ease",
            }}
          >
            {icon}
          </span>

          {/* LABEL */}

          {!collapsed && (
            <span
              style={{
                color: isActive ? "#B5183F" : "#555",

                transition: "color .2s ease",

                whiteSpace: "nowrap",

                flex: 1,
              }}
            >
              {label}
            </span>
          )}

          {/* ACTIVE INDICATOR */}

          {isActive && !collapsed && (
            <span
              style={{
                width: "4px",
                height: "24px",

                borderRadius: "10px",

                backgroundColor: "#B5183F",

                position: "absolute",

                [isRTL ? "left" : "right"]: "4px",
              }}
            />
          )}
        </>
      )}
    </NavLink>
  );
}

export default Sidbar;